

export default () => {

    var projects = document.getElementsByClassName('project');

    Array.prototype.forEach.call(projects, function(project) {
        project.addEventListener("mouseover",function() {
            if( this.dataset.rollBack != ''){
                let colorfont = (this.dataset.rollFont != '')?this.dataset.rollFont:'unset';
                this.setAttribute('style', 'background-color:' + this.dataset.rollBack +'; color:' + colorfont +';');
            }
    
        },false);
    
        project.addEventListener("mouseout", function() {
            this.setAttribute('style', 'background-color:unset; color:unset;');
        }, false);
    });

};